import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import { termsAr } from './terms-ar';
import { termsCo } from './terms-co';

ReactModal.setAppElement('body');

export default (particularForm) =>
  class Form extends React.Component<any, any> {
    constructor(props) {
      super(props);
      const { initValues } = this.props;
      this.state = {};
    }

    handleChange(event) {
      const fieldName = event.target.name;
      const fieldValue = event.target.value;
      const { fields } = this.props;

      let newFields = {
        ...this.props.fields,
        [fieldName]: fieldValue,
      };

      if (['conditions'].indexOf(fieldName) !== -1) {
        newFields = {
          ...newFields,
          conditions: !fields.conditions,
        };
      }

      this.props.onChange(newFields);
    }

    handleSubmit(e) {
      e.preventDefault();
      this.props.onSubmit(this.props.fields);
    }

    showTerms(e) {
      e.preventDefault();
      this.setState({ showModal: true });
    }

    handleCloseModal() {
      this.setState({ showModal: false });
    }

    getTerms() {
      const { country } = this.props;
      const terms = { CO: termsCo, AR: termsAr };

      return { __html: terms[country] };
    }

    render() {
      const { showModal } = this.state;
      const {
        docTypes,
        country,
        errors,
        sending,
        showValidations,
        errorMessage,
        fields,
      } = this.props;

      return (
        <div>
          {sending && (
            <div className="overlay">
              <div className="loader" />
            </div>
          )}
          {errorMessage && (
            <div id="error-box" className="error-box">
              <p>{errorMessage}</p>
            </div>
          )}
          <div className="info-box">
            {particularForm.renderFlowProcess.bind(this)()}
          </div>
          <div className="warning-box margin-bottom margin-top">
            {particularForm.renderAttentionMessage.bind(this)()}
          </div>
          <form
            id="dd-form"
            onSubmit={(e) => this.handleSubmit(e)}
            className={`${showValidations ? 'sended' : ''}`}
          >
            <div className="row-input">
              {/*client_number*/}
              <div
                className={`input ${errors['client_number'] ? 'invalid' : ''}`}
              >
                <label>Número de cliente en Booking.com</label>
                <input
                  name="client_number"
                  type="text"
                  value={fields.client_number}
                  onChange={(e) => this.handleChange(e)}
                  maxLength={8}
                />
                {errors['client_number'] && (
                  <div className="error-tooltip">{errors['client_number']}</div>
                )}
              </div>

              {/*property_number*/}
              <div
                className={`input ${errors['property_name'] ? 'invalid' : ''}`}
              >
                <label>Nombre de la propiedad</label>
                <input
                  name="property_name"
                  type="text"
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>

            <div className="row-input">
              {/*holder_name*/}
              <div
                className={`input ${errors['holder_name'] ? 'invalid' : ''}`}
              >
                <label>Nombre de propietario de cuenta bancaria</label>
                <input
                  value={fields.holder_name}
                  name="holder_name"
                  type="text"
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
            <div className="row-input">
              {/*email*/}
              <div className={`input ${errors['email'] ? 'invalid' : ''}`}>
                <label>Email</label>
                <input
                  value={fields.email}
                  name="email"
                  type="text"
                  onChange={(e) => this.handleChange(e)}
                />
              </div>

              {/*cuit*/}
              {particularForm.renderDocumentFields.bind(this)()}
            </div>
            <div className="row-input">
              {/*invoice_number*/}
              <div
                className={`input ${errors['invoice_number'] ? 'invalid' : ''}`}
              >
                <ReactTooltip
                  id="invoice_number"
                  place="top"
                  type="dark"
                  effect="solid"
                >
                  <span>
                    Puedes ingresar múltiples facturas separadas por coma
                    (máximo 10 facturas)
                  </span>
                </ReactTooltip>
                <label>
                  <span>
                    Número de factura{' '}
                    <a className="info" data-tip data-for="invoice_number" />
                  </span>
                </label>
                <input
                  value={fields.invoice_number}
                  name="invoice_number"
                  type="text"
                  onChange={(e) => this.handleChange(e)}
                  maxLength={109}
                />

                {errors['invoice_number'] && (
                  <div className="error-tooltip">
                    {errors['invoice_number']}
                  </div>
                )}
              </div>

              {/*amount*/}
              <div className={`input ${errors['amount'] ? 'invalid' : ''}`}>
                {particularForm.renderAmountTitle.bind(this)()}
                <div className="group">
                  <span className="symbol">$</span>
                  <input
                    className="small"
                    name="amount"
                    type="text"
                    value={fields.amount}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                {errors['amount'] && (
                  <div className="error-tooltip">{errors['amount']}</div>
                )}
              </div>
            </div>
            <div className="row-input">
              {particularForm.renderBankFields.bind(this)()}
            </div>

            <div className="row-input">
              <div className="conditions">
                <label>
                  <input
                    type="checkbox"
                    value={fields.conditions}
                    onChange={(e) => this.handleChange(e)}
                    name="conditions"
                  />{' '}
                  Acepto los{' '}
                  <a onClick={(e) => this.showTerms(e)} href="#">
                    Términos y Condiciones
                  </a>{' '}
                  para que{' '}
                  <a target="_blank" href="http://booking.com">
                    Booking.com
                  </a>{' '}
                  utilice el Débito Directo de mi cuenta bancaria
                </label>
                <ReactModal
                  isOpen={showModal}
                  contentLabel="Minimal Modal Example"
                  className="terms_modal"
                >
                  <div dangerouslySetInnerHTML={this.getTerms()} />
                  <button onClick={this.handleCloseModal}>
                    Cerrar
                  </button>
                </ReactModal>
              </div>
            </div>

            <div className="submit">
              <button type="submit">Enviar</button>
            </div>
          </form>
        </div>
      );
    }
  };
